import WebLLCRESTApi from "../api/api";
import UUID from "../util/uuid";
import $ from 'jquery';

export default {
  name: "AddClientPage",
  
  created() {
    this.api = new WebLLCRESTApi("Client-Pages", this.$router);
  },
  
  props: {
      clientId: {
          type: String,
      },
  },
  
  data() {
    return {
      txtURL: "",
      cmbLinkType: "positive"
    }
  },
  
  methods: {
    async onAddPage() {
      const newPageDetails = {
        id: UUID.genUuidV4(),
        url: this.txtURL,
        linkType: this.cmbLinkType,
        category: "link",
        hasLogin: false,
        clientId: this.clientId
      };
      
      const res = await this.api.addData(newPageDetails);
      const json = await res.json();
      
      this.$emit('added', json.id);
      $('#modal-add-page-data').modal('toggle');
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/AddClientPage.js